import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18533
// Новый экран шага флоу оверквоты cleared
export const overquotaNewCleared: boolean | undefined = getFeature('overquota-new-cleared');
